import Abstract from "../../../../abstract-view/abstract.js";

import {
  SliderTrigger
} from "../../../const.js";

import {Slider as Lexicon} from "../../lexicon.js";

const createSliderTemplate = () => {
  return (
    `<div class="filter-slider">
      <button
        class="filter-slider__button filter-slider__button_from"
        data-type="${SliderTrigger.FROM}"
        type="button">
        <span class="visually-hidden">${Lexicon.FROM}</span>
      </button>
      <button
        class="filter-slider__button filter-slider__button_to"
        data-type="${SliderTrigger.TO}"
        type="button">
        <span class="visually-hidden">${Lexicon.TO}</span>
      </button>
      <div class="filter-slider__range filter-slider__range_active"></div>
      <div class="filter-slider__range filter-slider__range_base"></div>
    </div>`
  );
};

import {
  createElement
} from "../../../../render/render.js";

export default class Slider extends Abstract {
  constructor() {
    super();

    this._buttonFromElement = null;
    this._buttonToElement = null;
    this._baseRangeElement = null;
    this._activeRangeElement = null;

    this._activeRangeClickHandler = this._activeRangeClickHandler.bind(this);
    this._baseRangeClickHandler = this._baseRangeClickHandler.bind(this);
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
      this._buttonFromElement = this._element.querySelector(`.filter-slider__button_from`);
      this._buttonToElement = this._element.querySelector(`.filter-slider__button_to`);
      this._baseRangeElement = this._element.querySelector(`.filter-slider__range_base`);
      this._activeRangeElement = this._element.querySelector(`.filter-slider__range_active`);
    }

    return this._element;
  }

  getElementOffset() {
    return this.getElement().getBoundingClientRect().x || this.getElement().getBoundingClientRect().left;
  }

  getButtonFromElement() {
    return this._buttonFromElement;
  }

  getButtonFromElementOffset() {
    const offset = this.getButtonFromElement().getBoundingClientRect().x || this.getButtonFromElement().getBoundingClientRect().left;
    return offset + this.getButtonFromElement().offsetWidth / 2;
  }

  getButtonToElement() {
    return this._buttonToElement;
  }

  getButtonToElementOffset() {
    const offset = this.getButtonToElement().getBoundingClientRect().x || this.getButtonToElement().getBoundingClientRect().left;
    return offset + this.getButtonToElement().offsetWidth / 2;
  }

  getBaseRangeElement() {
    return this._baseRangeElement;
  }

  getActiveRangeElement() {
    return this._activeRangeElement;
  }

  getActiveRangeElementOffset() {
    return this.getActiveRangeElement().getBoundingClientRect().x || this.getActiveRangeElement().getBoundingClientRect().left;
  }

  setActiveButton(type) {
    switch (type) {
      case SliderTrigger.FROM:
        this._buttonFromElement.classList.add(`filter-slider__button_active`);
        this._buttonToElement.classList.remove(`filter-slider__button_active`);
        break;
      case SliderTrigger.TO:
        this._buttonToElement.classList.add(`filter-slider__button_active`);
        this._buttonFromElement.classList.remove(`filter-slider__button_active`);
        break;
    }
  }

  setActiveRangeClickHandler(callback) {
    this._callback.activeRangeClick = callback;
    this._activeRangeElement.addEventListener(`click`, this._activeRangeClickHandler);
  }

  setBaseRangeClickHandler(callback) {
    this._callback.baseRangeClick = callback;
    this._baseRangeElement.addEventListener(`click`, this._baseRangeClickHandler);
  }

  _getTemplate() {
    return createSliderTemplate();
  }

  _activeRangeClickHandler(evt) {
    this._callback.activeRangeClick(evt);
  }

  _baseRangeClickHandler(evt) {
    this._callback.baseRangeClick(evt);
  }
}
